import React from 'react';
import PropTypes from 'prop-types';
import './AddRemoveMembersModal.scss';

class AddRemoveMembersModal extends React.Component {
    state = {
        search: '',
        selected: [],
    };

    handleSearchChange = (e) => {
        this.setState({ search: e.target.value });
    };

    toggleSelect = (user) => {
        this.setState((prevState) => {
            const isSelected = prevState.selected.includes(user);
            return {
                selected: isSelected
                    ? prevState.selected.filter((tempUser) => tempUser !== user)
                    : [...prevState.selected, user],
            };
        });
    };

    handleConfirm = () => {
        const { onConfirm, channelId, mode } = this.props;
        console.log('Selected users:', this.state.selected);
        onConfirm(this.state.selected, channelId, mode);
    };

    render() {
        const { allUsers, channelUsers, onClose, title = 'Add Group Members', confirmLabel = 'Add', mode, channelId } = this.props;
        const { search, selected } = this.state;

        const channelUserIds = new Set(channelUsers.map((u) => u.owner_id));

        const filteredAllUsers = allUsers.filter(
            (user) =>
                user.status === 'active' &&
                !channelUserIds.has(user.owner_id) && user.owner_id != 134 && // exclude users already in channel
                (
                    (user.first_name?.toLowerCase().includes(search.toLowerCase()) || '') ||
                    (user.position?.toLowerCase().includes(search.toLowerCase()) || '')
                )
        );

        const actionLabel = mode === 'add' ? `Add` : `Remove`;

        return (
            <div className="members-modal-overlay">
                <div className="members-modal-content">
                    <div className="members-modal-header">
                        <span>{title}</span>
                        <button className="close-button" onClick={onClose}>&times;</button>
                    </div>

                    <div className="modal-search">
                        <input
                            type="text"
                            value={search}
                            onChange={this.handleSearchChange}
                            placeholder="Search by name or job title"
                        />
                    </div>

                    <div className="modal-list">
                        {(mode === 'add' ? filteredAllUsers : channelUsers).map((user) => (
                            <div
                                key={user.owner_id}
                                className="member-item"
                                onClick={() => this.toggleSelect(user)}
                            >
                                <div className="left">
                                    <img
                                        src={user.profile_image_thumb_url || '/icons/default-profile-thumb.svg'}
                                        alt="avatar"
                                        className="avatar"
                                    />
                                    <div className="info">
                                        <div className="name">{user.first_name} {user.last_name}</div>
                                        <div className="position">{user.position}</div>
                                    </div>
                                </div>
                                <div className={`checkmark ${selected.includes(user) ? (mode === 'add' ? 'checked' : 'checked-red') : ''}`} />
                            </div>
                        ))}
                    </div>

                    <div className="modal-footer">
                        <button className="cancel-button" onClick={onClose}>Cancel</button>
                        <button
                            className="confirm-button"
                            onClick={this.handleConfirm}
                            disabled={selected.length === 0}
                        >
                            {confirmLabel} {selected.length > 0 ? selected.length : ''}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


AddRemoveMembersModal.propTypes = {
    allUsers: PropTypes.array.isRequired,
    channelUsers: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    confirmLabel: PropTypes.string,
    mode: PropTypes.oneOf(['add', 'remove']).isRequired,

};


export default AddRemoveMembersModal;
